import httpClient from "@/apis/base/axios-httpclient";
import BaseAPI from "@/apis/base/base-api";
class CustomerContactsAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "PaymentRequest";
  controllerName = "customers";

  /**
   * @override: Lấy dữ liệu danh sách
   * Created by: TMQUY 28/08/2021
   */
  getList(payload) {
    // URL mặc định
    let param = {
      maxResultCount: payload.take || 10,
      filter: payload.filter || null,
      skipCount: payload.skip || 0,
      sorting: payload.Sort || null,
    };
    let url = this.getAPIUrl() + "/list";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }
  /**
   * Tạo mới customer
   * CreatedBy: tmquy (16/06/2022)
   */
  createCustomer(payload) {
    let url = this.getAPIUrl();
    // Build tham số
    let request = {
      url: url,
      data: payload,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin khách hàng qua id
   * CreatedBy: pvtruong (16/07/2022)
   */
  getCustomerById(id) {
    let url = this.getAPIUrl() + "/" + id;
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra xem MST hoặc email đã tồn tai hay chưa
   * CreatedBy: tmquy (13/07/2022)
   */
  checkInvalid(value) {
    let url = this.getAPIUrl() + `/checkInvalid?input=${value}`;
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }
}
export default new CustomerContactsAPI();
